"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSearchInput = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../../Icon");
exports.SelectSearchInput = react_1.default.forwardRef(function (props, ref) {
    var className = props.className, inputProps = __rest(props, ["className"]);
    return (react_1.default.createElement("div", { className: "c-search c-dropdown__search" },
        react_1.default.createElement(Icon_1.Icon, { iconName: "icon-search" }),
        react_1.default.createElement("input", __assign({ className: "c-dropdown__search-input c-input +text " + (className !== null && className !== void 0 ? className : "") }, inputProps, { type: "search", ref: ref }))));
});
//# sourceMappingURL=SelectSearchInput.js.map